import { render, staticRenderFns } from "./cis-seeds.vue?vue&type=template&id=2d4a6c5b"
import script from "./cis-seeds.vue?vue&type=script&lang=js"
export * from "./cis-seeds.vue?vue&type=script&lang=js"
import style0 from "./cis-seeds.vue?vue&type=style&index=0&id=2d4a6c5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports